import React, { useCallback } from 'react'

import { Marker } from 'react-map-gl'
import pinSliceIconImage from 'src/assets/Images/1st_Tier_Slice.svg'

import { PinData } from './types'

interface Props extends PinData {
  onSelect(pin: string): void
}

export const Pin: React.FC<Props> = ({
  latitude = 0,
  longitude = 0,
  onSelect,
  id,
}) => {
  const onClick: React.MouseEventHandler = useCallback(
    e => {
      e.stopPropagation()
      onSelect(id)
    },
    [onSelect, id]
  )

  return (
    <Marker latitude={latitude} longitude={longitude} aria-hidden>
      <div
        onClick={onClick}
        aria-hidden
        tabIndex={-1}
        style={{ cursor: 'pointer' }}
      >
        <img src={pinSliceIconImage} alt="location" aria-hidden />
      </div>
    </Marker>
  )
}
